import { useCallback, useState } from 'react';
import { useDataService } from '../../../services/ApiDataService';
import { useRequestState } from '../../../utilities/Hooks';

const TEST_URL = '/ipm/ng1/test';

export default function useNg1PairingVerify() {
    const { isLoading, methods } = useRequestState();
    const dataService = useDataService();

    const [nG1PairingSuccess, setNg1PairingSuccess] = useState(false);
    const [hasTested, setHasTested] = useState(false);

    const testNg1Server = useCallback(
        async ({ ng1Url, preSharedKey, certCheck, assignedServerId }) => {
            methods.onInit();
            setHasTested(true);

            try {
                const response = await dataService.post(TEST_URL, {
                    ng1Url,
                    preSharedKey,
                    certCheck,
                    assignedServerId,
                });

                setNg1PairingSuccess(true);
                methods.onLoad(response);
            } catch (e) {
                setNg1PairingSuccess(false);
                methods.onError(e);
            }
        },
        [dataService, methods]
    );

    return {
        testNg1Server,
        isLoading,
        nG1PairingSuccess,
        hasTested,
    };
}
